import React, { useEffect, useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useFonts, Lato_400Regular, Lato_700Bold, Lato_900Black } from '@expo-google-fonts/lato';
import AppLoading from 'expo-app-loading';
import 'react-native-gesture-handler';

import HomeScreen from './src/components/HomeScreen';
import EventScreen from './src/components/EventScreen';

const Stack = createNativeStackNavigator();

export default function App() {
	const [data, setData] = useState([]);
	const [errorMessage, setErrorMessage] = useState('');
	const [appIsReady, setAppIsReady] = useState(false);
	let [fontsLoaded] = useFonts({
		Lato_400Regular,
		Lato_700Bold,
		Lato_900Black,
	});

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = () => {
		fetch('https://guarded-spire-87601.herokuapp.com/api/v2/events')
			.then((response) => response.json())
			.then((json) => {
				setData(json);
			})
			.then(() => {
				setAppIsReady(true);
			})

			.catch((error) => setErrorMessage(error));
	};

	if (!fontsLoaded || !appIsReady) {
		return <AppLoading />;
	}

	return (
		<NavigationContainer>
			<Stack.Navigator initialRouteName="Home" newData={data}>
				<Stack.Screen
					name="Home"
					component={HomeScreen}
					initialParams={{ newData: data }}
					options={{
						gestureDirection: 'horizontal',
						headerTitle: 'AalborgTonight',
						headerTransparent: true,
						headerTintColor: '#fff',
						headerTitle: '',
					}}
				></Stack.Screen>
				<Stack.Screen name="Event" component={EventScreen} options={{ gestureDirection: 'horizontal', animation: 'slide_from_right', title: '', headerTransparent: true }}></Stack.Screen>
			</Stack.Navigator>
		</NavigationContainer>
	);
}
